import { SidebarComponent } from '../sidebar-component.class';

export class CSSHandler {
    private styleElement: HTMLStyleElement | null = null;

    public static SIDEBAR_STYLE_ID: string = 'wecdev-bar-style';

    constructor() {}

    public setStyle(shadow: ShadowRoot): void {
        this.styleElement = document.createElement('style');
        this.styleElement.id = CSSHandler.SIDEBAR_STYLE_ID;
        this.styleElement.textContent = `
            :host {
                --sidebar-primary: #2c3e50;
                --sidebar-primary-light: #34495e;
                --sidebar-accent: #3498db;
                --sidebar-accent-dark: #2c81c2;
                --sidebar-radius-sm: .5rem;
                --sidebar-radius-md: .75rem;
                --sidebar-radius-lg: 1rem;
                --sidebar-ease: cubic-bezier(.4,0,.2,1);
                --sidebar-shadow-sm: 0 2px 8px rgba(15,23,42,.14);
                --sidebar-shadow-md: 0 6px 18px rgba(15,23,42,.2);
                --sidebar-shadow-lg: 0 22px 46px rgba(15,23,42,.28);
                --sidebar-danger: #dc3545;
                --sidebar-danger-dark: #b02a37;
                --sidebar-success: #2ecc71;
                --sidebar-success-dark: #27ae60;
            }

            .${SidebarComponent.SIDEBAR_BUTTON_CLASS},
            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}:hover {
                display: inline-flex !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 0.55rem 1.1rem !important;
                font-size: 0.95rem !important;
                font-weight: 600 !important;
                letter-spacing: .01em !important;
                line-height: 1.4 !important;
                color: #fff !important;
                text-align: center !important;
                text-decoration: none !important;
                border: 1px solid rgba(255,255,255,.2) !important;
                border-radius: var(--sidebar-radius-md) !important;
                cursor: pointer !important;
                background: linear-gradient(135deg, var(--sidebar-accent), var(--sidebar-accent-dark)) !important;
                box-shadow: var(--sidebar-shadow-sm), inset 0 1px 0 rgba(255,255,255,.2) !important;
                transition: transform .2s var(--sidebar-ease), box-shadow .2s var(--sidebar-ease), filter .2s var(--sidebar-ease) !important;
            }

            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}.danger {
                background: linear-gradient(135deg, var(--sidebar-danger), var(--sidebar-danger-dark)) !important;
            }

            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}.active {
                background: linear-gradient(135deg, var(--sidebar-success), var(--sidebar-success-dark)) !important;
                animation: wecdev-pulse 1.6s var(--sidebar-ease) infinite !important;
            }

            @keyframes wecdev-pulse {
                0%, 100% { box-shadow: var(--sidebar-shadow-sm), 0 0 0 0 rgba(46, 204, 113, .55); }
                50% { box-shadow: var(--sidebar-shadow-sm), 0 0 0 6px rgba(46, 204, 113, 0); }
            }

            .wecdev-area-picker-hint {
                font-size: 11px !important;
                line-height: 1.4 !important;
                color: #64748b !important;
            }

            .wecdev-area-picker-selection-list {
                display: flex !important;
                flex-wrap: wrap !important;
                gap: 4px !important;
            }

            .wecdev-area-picker-chip-mini {
                display: inline-flex !important;
                align-items: center !important;
                gap: 2px !important;
                background: rgba(52,152,219,.12) !important;
                color: #2c3e50 !important;
                border-radius: 999px !important;
                padding: 2px 6px 2px 10px !important;
                font-size: 11px !important;
            }

            .wecdev-area-picker-chip-mini button {
                border: none !important;
                background: transparent !important;
                color: #94a3b8 !important;
                cursor: pointer !important;
                font-size: 12px !important;
                line-height: 1 !important;
                padding: 0 2px !important;
            }

            .wecdev-area-picker-chip-mini button:hover {
                color: #dc3545 !important;
            }

            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}:hover,
            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}:focus-visible {
                transform: translateY(-2px) !important;
                box-shadow: var(--sidebar-shadow-md), inset 0 1px 0 rgba(255,255,255,.28) !important;
                filter: brightness(1.06) !important;
                outline: none !important;
            }

            .${SidebarComponent.SIDEBAR_BUTTON_CLASS}:active {
                transform: translateY(0) !important;
                box-shadow: var(--sidebar-shadow-sm), inset 0 1px 2px rgba(0,0,0,.1) !important;
            }

            .${SidebarComponent.SIDEBAR_CLASS} {
                position: fixed !important;
                overflow: hidden !important;
                background: linear-gradient(180deg, #ffffff 0%, #f4f6f8 100%) !important;
                border: 1px solid rgba(15,23,42,.06) !important;
                z-index: 999999 !important;
                box-shadow: var(--sidebar-shadow-lg) !important;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.vertical .wecdev-sidebar-first {
                position: absolute;
                top: -55px;
                left: -40px;
                width: calc(100% + 80px);
                height: 230px;
                background: linear-gradient(135deg, var(--sidebar-primary), var(--sidebar-primary-light));
                box-shadow: 0 16px 28px -14px rgba(15,23,42,.5);
                transform: rotate(3deg);
                z-index: 4;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.vertical .wecdev-sidebar-first::after {
                content: "";
                position: absolute;
                bottom: 18px;
                left: 0;
                width: 100%;
                height: 1px;
                background: linear-gradient(90deg, transparent, var(--sidebar-accent), transparent);
                opacity: .85;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.vertical .wecdev-sidebar-second {
                position: absolute;
                bottom: -55px;
                left: -40px;
                width: calc(100% + 80px);
                height: 230px;
                background: linear-gradient(135deg, var(--sidebar-primary), var(--sidebar-primary-light));
                box-shadow: 0 -16px 28px -14px rgba(15,23,42,.5);
                transform: rotate(-3deg);
                z-index: 4;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.vertical .wecdev-sidebar-second::before {
                content: "";
                position: absolute;
                top: 18px;
                left: 0;
                width: 100%;
                height: 1px;
                background: linear-gradient(90deg, transparent, var(--sidebar-accent), transparent);
                opacity: .85;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.horizontal .wecdev-sidebar-first {
                position: absolute;
                top: -40px;
                left: -60px;
                height: calc(100% + 80px);
                width: 220px;
                background: linear-gradient(135deg, var(--sidebar-primary), var(--sidebar-primary-light));
                box-shadow: 16px 0 28px -14px rgba(15,23,42,.5);
                transform: rotate(-3deg);
                z-index: 4;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.horizontal .wecdev-sidebar-first::after {
                content: "";
                position: absolute;
                right: 18px;
                top: 0;
                height: 100%;
                width: 1px;
                background: linear-gradient(180deg, transparent, var(--sidebar-accent), transparent);
                opacity: .85;
            }


            .${SidebarComponent.SIDEBAR_CLASS}.horizontal .wecdev-sidebar-second {
                position: absolute;
                right: -60px;
                bottom: -40px;
                height: calc(100% + 80px);
                width: 220px;
                background: linear-gradient(135deg, var(--sidebar-primary), var(--sidebar-primary-light));
                box-shadow: -16px 0 28px -14px rgba(15,23,42,.5);
                transform: rotate(3deg);
                z-index: 4;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.horizontal .wecdev-sidebar-second::before {
                content: "";
                position: absolute;
                left: 18px;
                top: 0;
                height: 100%;
                width: 1px;
                background: linear-gradient(180deg, transparent, var(--sidebar-accent), transparent);
                opacity: .85;
            }

            .wecdev-close-btn {
                position: absolute !important;
                top: 15px !important;
                right: 15px !important;
                width: 26px !important;
                height: 26px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 0 !important;
                background: rgba(255,255,255,.14) !important;
                border: 1px solid rgba(255,255,255,.55) !important;
                border-radius: 50% !important;
                cursor: pointer !important;
                font-size: 13px !important;
                color: #fff !important;
                z-index: 10 !important;
                backdrop-filter: blur(4px) !important;
                -webkit-backdrop-filter: blur(4px) !important;
                transition: transform .2s var(--sidebar-ease), background-color .2s var(--sidebar-ease), box-shadow .2s var(--sidebar-ease) !important;
            }

            .wecdev-close-btn:hover,
            .wecdev-close-btn:focus-visible {
                background: rgba(255,255,255,.3) !important;
                transform: scale(1.08) !important;
                outline: none !important;
            }

            .wecdev-close-btn:active {
                transform: scale(.96) !important;
            }

            .wecdev-sidebar-pattern {
                position: absolute;
                inset: 0;
                z-index: 3;
                background-image: radial-gradient(var(--sidebar-accent) 1px, transparent 1px);
                background-size: 10px 10px;
                opacity: .16;
                pointer-events: none;
            }

            .${SidebarComponent.SIDEBAR_CLASS}.vertical .wecdev-sidebar-pattern {
                clip-path: inset(170px 0 170px 0);
            }

            .${SidebarComponent.SIDEBAR_CLASS}.horizontal .wecdev-sidebar-pattern {
                clip-path: inset(0 170px 0 170px);
            }

            .wecdev-module-wrapper {
                position: absolute !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                gap: .3rem !important;
                padding: .2rem .5rem .55rem !important;
                border: 1px solid transparent !important;
                border-radius: var(--sidebar-radius-sm) !important;
                transition: border-color .2s var(--sidebar-ease), background-color .2s var(--sidebar-ease), box-shadow .2s var(--sidebar-ease) !important;
                overflow: visible !important;
                cursor: pointer !important;
                z-index: 100 !important;
            }

            .wecdev-module-wrapper:hover,
            .wecdev-module-wrapper:focus-within {
                border-color: var(--sidebar-accent) !important;
                background: rgba(52,152,219,.08) !important;
                box-shadow: var(--sidebar-shadow-sm) !important;
            }

            .wecdev-module-wrapper > .wecdev-legend {
                font-size: 10px !important;
                font-weight: 500 !important;
                letter-spacing: .02em !important;
            }

            .wecdev-legend {
                display: block !important;
                width: 100% !important;
                max-width: 100% !important;
                padding: 0 !important;
                margin: 0 0 .45rem !important;
                font-size: 1.5rem !important;
                font-weight: 600 !important;
                letter-spacing: .01em !important;
                line-height: 1 !important;
                color: var(--sidebar-accent) !important;
                white-space: normal !important;
            }

            .ui-menu-item-wrapper {
                display: flex !important;
                align-items: center !important;
                min-height: 32px !important;
                padding: .35rem .5rem !important;
                border-radius: var(--sidebar-radius-sm) !important;
                transition: background-color .18s var(--sidebar-ease), color .18s var(--sidebar-ease), transform .18s var(--sidebar-ease) !important;
            }

            .ui-menu-item-wrapper:hover {
                background: rgba(255,255,255,.14) !important;
                transform: translateX(2px) !important;
            }

            .ui-state-active > .ui-icon {
                color: #fff !important;
            }

            .wecdev-hamburger-btn {
                position: absolute !important;
                top: -8px !important;
                right: -46px !important;
                width: 30px !important;
                height: 30px !important;
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                padding: 0 !important;
                background: transparent !important;
                border: 1px solid rgba(255,255,255,.65) !important;
                border-radius: 50% !important;
                cursor: pointer !important;
                font-size: 15px !important;
                color: var(--sidebar-accent) !important;
                transition: transform .2s var(--sidebar-ease), opacity .2s var(--sidebar-ease), background-color .2s var(--sidebar-ease), box-shadow .2s var(--sidebar-ease) !important;
                opacity: 0 !important;
                box-shadow: var(--sidebar-shadow-sm) !important;
                backdrop-filter: blur(6px) !important;
                -webkit-backdrop-filter: blur(6px) !important;
            }

            .wecdev-hamburger-btn:hover,
            .wecdev-hamburger-btn:focus-visible {
                background: transparent !important;
                transform: scale(1.08) !important;
                box-shadow: var(--sidebar-shadow-md) !important;
                outline: none !important;
            }

            .module-menu {
                position: absolute !important;
                display: none !important;
                top: 20px !important;
                right: -42px !important;
                width: 160px !important;
                z-index: 1000 !important;
                padding: .45rem !important;
                border: 1px solid rgba(255,255,255,.12) !important;
                border-radius: var(--sidebar-radius-lg) !important;
                background: transparent !important;
                box-shadow: var(--sidebar-shadow-md) !important;
                backdrop-filter: blur(10px) !important;
                -webkit-backdrop-filter: blur(10px) !important;
            }

            .wecdev-module-wrapper:hover .move-buttons,
            .wecdev-module-wrapper:hover .wecdev-hamburger-btn {
                opacity: 1 !important;
            }

            .fa-solid,
            .fas {
                margin: 0 .45rem !important;
                transition: transform .2s var(--sidebar-ease), opacity .2s var(--sidebar-ease) !important;
            }

            .fa-solid:hover,
            .fas:hover {
                transform: scale(1.12) !important;
            }
        `;

        let existingStyle = shadow.querySelector(`#${CSSHandler.SIDEBAR_STYLE_ID}`);
        if (!existingStyle) {
            shadow.appendChild(this.styleElement);
        }
    }
}
